'use client';
import { from } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import {
	ClaropaySDKApi,
	ICardClaroPay,
	IProcessPayment,
	IUserConfirmation,
	IUserPasswordLess,
} from '@claropay/web-portal-sdk';
import * as claropaywebsdk from '@claropay/web-portal-sdk'

let claropaywebportalsdk: ClaropaySDKApi;

export const useClaropaySdk = () => {


	const initialize = () => {
		claropaywebportalsdk = new claropaywebsdk.ClaropaySDKApi(
			`${process.env.REACT_APP_SDK_API_KEY}`,
			(resourceInformation: any, errorInitialize: any) => {
				console.log("*** WEB SDK Launch ***")
			},
			{
				apiKey: process.env.REACT_APP_SDK_API_KEY
					? process.env.REACT_APP_SDK_API_KEY
					: '',
				claroID: process.env.REACT_APP_SDK_CLARO_ID,
				apiKeyClaroID: process.env.REACT_APP_SDK_API_KEY_CLARO_ID,
				passwordLess: process.env.REACT_APP_SDK_API_PASSWORDLESS,
				apiKeyPasswordLess: process.env.REACT_APP_SDK_API_KEY_PASSWORDLESS,
				appsync: process.env.REACT_APP_SDK_API_APPSYNC,
				apiKeyAppsync: process.env.REACT_APP_SDK_API_KEY_APPSYNC,
				calculadoraComisiones:
					process.env.REACT_APP_SDK_API_CALCULADORA_COMISIONES,
				apiKeyCalculadoraComisiones:
					process.env.REACT_APP_SDK_API_KEY_CALCULADORA_COMISIONES,
				cardManagement: process.env.REACT_APP_SDK_API_CARD_MANAGEMENT,
				apiKeyCardManagement:
					process.env.REACT_APP_SDK_API_KEY_CARD_MANAGEMENT,
				proxyService: process.env.REACT_APP_SDK_API_PROXY_SERVICE,
				apiKeyProxyService: process.env.REACT_APP_SDK_API_KEY_PROXY_SERVICE,
				binesCatalog: process.env.REACT_APP_SDK_BINES_CATALOG,
				messagingCatalog: process.env.REACT_APP_SDK_MESSAGING_CATALOG,
				apiKeyMessagingCatalog:
					process.env.REACT_APP_SDK_API_KEY_MESSAGING_CATALOG,
				appVersion: process.env.REACT_APP_SDK_APP_VERSION,
				payment: process.env.REACT_APP_SDK_API_PAYMENT,
				apikeyPayment: process.env.REACT_APP_SDK_API_KEY_PAYMENT,
				passwordEncrypt: window.atob(
					process.env.REACT_APP_SDK_PASSWORD_ENCRYPT
						? process.env.REACT_APP_SDK_PASSWORD_ENCRYPT
						: '4a$NGEkc1dvcjBs',
				),
				checkPayment: process.env.REACT_APP_SDK_CHECK_PAYMENT,
				apiKeycheckPayment: process.env.REACT_APP_SDK_API_KEY_CHECK_PAYMENT,
				validateAccountNumber: process.env.REACT_APP_VALIDATE_ACCOUNT_NUMBER,
				apiKeyValidateAccountNumber: process.env.REACT_APP_KEY_VALIDATE_ACCOUNT_NUMBER,
				createCard: process.env.REACT_APP_CREATE_CARD,
				apiKeyCreateCard: process.env.REACT_APP_KEY_CREATE_CARD,
				deleteCard: process.env.REACT_APP_DELETE_CARD,
				apiKeyDeleteCard: process.env.REACT_APP_KEY_DELETE_CARD,
			},
		);
	};

	const wrapperObservable = (pusblish: any) => {
		console.debug('wrapperObservable');
		return from(pusblish).pipe(
			map((x: any) => {
				return JSON.parse(x);
			}),
			catchError((error) => {
				return of({
					success: false,
					data: {
						error: error.toString(),
					},
				}).pipe((x) => x);
			}),
		);
	};

	const setState = (id: string, state: any) => {
		console.debug(`id ${id}, state ${state}`);
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.setState(id, state, resolve, reject);
		});
		return wrapperObservable(publish);
	};

	const getState = (id: string) => {
		console.debug(`id ${id}`);
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.getState(id, resolve, reject);
		});
		return wrapperObservable(publish);
	};

	const userExist = (id: string) => {
		console.debug(`id, string ${id}`);
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.userExist(id, resolve, reject);
		});
		return wrapperObservable(publish);
	};

	const createUserPasswordLess = (userPasswordLess: IUserPasswordLess) => {
		console.debug(
			`userPasswordLess, IUserPasswordLess ${JSON.stringify(userPasswordLess)}`,
		);
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.createUserPasswordLess(
				userPasswordLess,
				resolve,
				reject,
			);
		});
		return wrapperObservable(publish);
		// mock for testing
		// return of({
		//   success: true,
		//   data: {
		//     msisdn: '+528126275000',
		//     username: '3b54ad9d-c578-447c-910b-09a9273ae624',
		//     session: '48b0a50a-ac8a-4f1e-ae31-efee21f11a7d',
		//     secondsForNewRequest: 30,
		//     countOTPs: 1,
		//     creationDate: 1693947953874,
		//     tokenOperation: '83c24a85e3822fa21a0909c070ad1abc',
		//   },
		// }).pipe((x: any) => x);
	};

	const confirmationCodeNewUserPasswordLess = (user: IUserConfirmation) => {
		console.debug(`user: IUserConfirmation ${JSON.stringify(user)}`);
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.confirmationCodeNewUserPasswordLess(
				user,
				resolve,
				reject,
			);
		});
		return wrapperObservable(publish);
		// mock for testing
		// return of({
		//   access_token: 'eyJraWQiOiJ2WU5XcFlBcTJ4ZStrREdTRDZ5TjMxO...',
		//   expires_in: 3600,
		//   id_token: 'eyJraWQiOiI2VHM3OERi...',
		//   refresh_token: 'eyJjdHkiOiJKV1QiL...',
		//   token_type: 'Bearer',
		//   tokenOperation: 'af0deeb...',
		// }).pipe((x: any) => x);
	};

	const resendCodeUserPasswordLess = (userPasswordLess: IUserPasswordLess) => {
		console.debug(`userPasswordLess ${JSON.stringify(userPasswordLess)}`);
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.resendCodeUserPasswordLess(
				userPasswordLess,
				resolve,
				reject,
			);
		});
		return wrapperObservable(publish);
	};

	const initTokenUserPasswordLess = (phone: string) => {
		console.debug(`phone, string ${phone}`);
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.initTokenUserPasswordLess(phone, resolve, reject);
		});
		return wrapperObservable(publish);
	};

	const generateTokenUserPasswordLess = (
		msisdn: string,
		code: string,
		session: string,
	) => {
		console.debug(`msisdn, string ${msisdn}`);
		console.debug(`code, string ${code}`);
		console.debug(`session, string ${session}`);
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.generateTokenUserPasswordLess(
				msisdn,
				code,
				session,
				resolve,
				reject,
			);
		});
		return wrapperObservable(publish);
	};

	const getToken = () => {
		return new Promise(function (resolve, reject) {
			claropaywebportalsdk.getToken(resolve, reject);
		});
		//return wrapperObservable(publish);
	};

	const createUserTemporal = (phoneNumber: string) => {
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.createUserTemporal(phoneNumber, resolve, reject);
		});
		return wrapperObservable(publish);
	};

	const permanentUser = (phoneNumber: string) => {
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.permanentUser(phoneNumber, resolve, reject);
		});
		return wrapperObservable(publish);
	};

	const deleteUser = (phoneNumber: string) => {
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.deleteUser(phoneNumber, resolve, reject);
		});
		return wrapperObservable(publish);
	};

	const logout = () => {
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.logout(resolve, reject);
		});
		return wrapperObservable(publish);
	};

	const trustUser = () => {
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.trustUser(resolve, reject);
		});
		return wrapperObservable(publish);
	};

	const getProfile = () => {
		return new Promise(function (resolve, reject) {
			claropaywebportalsdk.getProfile(resolve, reject);
		});
		//return wrapperObservable(publish);
	};

	const appSync = (
		countryId: string,
		bundleID: string,
		bundleVersion: string,
		bankId: string,
	) => {
		return new Promise((resolve, reject) => {
			try {
				claropaywebportalsdk.appSync(
					countryId,
					bundleID,
					bundleVersion,
					bankId,
					(result: any) => {
						console.log("AppSync success");
						resolve(result);
					},
					(error: any) => {
						console.log("AppSync error");
						reject(error);
					}
				);
			} catch (error) {
				console.log("AppSync catch");
				reject(error);
			}
		})
	};

	const searchCard = (isTemporal: boolean) => {
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.searchCard(isTemporal, resolve, reject);
		});
		return wrapperObservable(publish);
	};

	const saveCard = (card: ICardClaroPay) => {
		return new Promise((resolve, reject) => {
			try {
				claropaywebportalsdk.saveCard(
					card, 
					(result: any) => {
						console.log("Save card success");
						resolve(result);
					},
					(error: any) => {
						console.log("Save card error");
						reject(error);
					}
				);
			} catch (error) {
				console.log("Save card catch");
				reject(error);
			}
		});
	};

	const processPayment = (
		payment: IProcessPayment,
		isTemporalUser: boolean,
	) => {
		console.log('hook');
		console.log(payment);
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.processPayment(
				payment,
				isTemporalUser,
				resolve,
				reject,
			);
		});
		return wrapperObservable(publish);
	};

	const calculateCommission = (
		serviceId: string,
		merchantId: string,
		amount: string,
		isClaroPay: string,
		cardId: string,
		appVersion: string,
		isClaroPartner: string,
	) => {
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.calculateCommission(
				serviceId,
				merchantId,
				amount,
				isClaroPay,
				cardId,
				appVersion,
				isClaroPartner,
				resolve,
				reject,
			);
		});
		return wrapperObservable(publish);
	};

	const downloadBinesCatalog = () => {
		return new Promise(function (resolve, reject) {
			claropaywebportalsdk.downloadBinesCatalog(resolve, reject);
		});
		// return wrapperObservable(publish);
	};

	const downloadMessaggingClaropay = () => {
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.downloadMessaggingClaropay(resolve, reject);
		});
		return wrapperObservable(publish);
	};

	const getMessaggingClaropay = (flux: string, code: string) => {
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.getMessaggingClaropay(flux, code, resolve, reject);
		});
		return wrapperObservable(publish);
	};

	const setToken = (isTemporalUser: boolean, token: any) => {
		return new Promise((resolve, reject) => {
			try {
				claropaywebportalsdk.setToken(
					isTemporalUser, 
					token, 
					(result: any) => {
						console.log("Set token success")
						resolve(result);
			 		}, 
					(error: any) => {
						console.log("Set token error");
						reject(error);
					}
				);
			} catch (error) {
				console.log("Set token catch");
				reject(error);
			}
		});
	};

	const getBin = (bin: string) => {
		return new Promise(function (resolve, reject) {
			claropaywebportalsdk.getBin(bin, resolve, reject);
		});
		//return wrapperObservable(publish);
	};

	const termsConditions = (msisdn: string) => {
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.termsConditions(msisdn, resolve, reject);
		});
		return wrapperObservable(publish);
	};

	const checkPayment = (authorizationId: string) => {
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.checkPayment(authorizationId, resolve, reject);
		});
		return wrapperObservable(publish);
	};

	const getBinInline = (bin: string) => {
		return claropaywebportalsdk.getBinInline(bin, null, null);
	};

	const sendOTP = (id: string, mail: string) => {
		console.debug(`id, string ${id}`);
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.sendOTP(id, mail, resolve, reject);
		});
		return wrapperObservable(publish);
	};

	const validateOTP = (user: IUserConfirmation) => {
		console.debug(`user: IUserConfirmation ${JSON.stringify(user)}`);
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.validateOTP(user, resolve, reject);
		});
		return wrapperObservable(publish);
	};

	return {
		initialize,
		setState,
		getState,
		userExist,
		createUserPasswordLess,
		confirmationCodeNewUserPasswordLess,
		resendCodeUserPasswordLess,
		initTokenUserPasswordLess,
		generateTokenUserPasswordLess,
		getToken,
		createUserTemporal,
		permanentUser,
		deleteUser,
		logout,
		getProfile,
		trustUser,
		appSync,
		searchCard,
		saveCard,
		processPayment,
		calculateCommission,
		downloadBinesCatalog,
		downloadMessaggingClaropay,
		getMessaggingClaropay,
		setToken,
		getBin,
		getBinInline,
		termsConditions,
		checkPayment,
		sendOTP,
		validateOTP,
	};
};

